import type { StreamlineFontSizeType } from '../streamlineIcon/constants';
import type { StreamlineIconProps } from '../streamlineIcon/StreamlineIcon';
import { OnErrorSad } from '../streamlineRegularIcon/OnErrorSad';

interface Props extends StreamlineIconProps {
  size?: StreamlineFontSizeType;
  color?: 'error';
}

export const ErrorIcon = ({ size, color, ...props }: Props) => (
  <OnErrorSad size={size} color={color} {...props} />
);
